var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"give","hide-footer":"","hide-header":""}},[_c('give')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }